import React from "react";

function Tile({ label, value }) {
  return (
    <div style={{ padding: 10, border: "1px solid var(--border)", borderRadius: 8, background: "#fff" }}>
      <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 15, fontWeight: 800, color: "var(--brown-deep)" }}>{value}</div>
    </div>
  );
}

const lblStyle = { fontSize: 11.5, fontWeight: 700, color: "var(--muted)", display: "block", marginBottom: 4 };
const tableHead = { padding: "8px 10px", fontSize: 11, fontWeight: 700, textAlign: "start", color: "var(--brown-deep)" };
const tableCell = { padding: "6px 10px", fontSize: 11.5, color: "var(--brown-deep)" };

export { Tile, lblStyle, tableHead, tableCell };
